<template>
  <div>
    <b-card>
      <b-card-title> RECIBO </b-card-title>
      <b-card-text>
        <b-row>
          <b-col>
            Recebemos de <b>{{ bill_data.bill.person.name }}</b>
            <span v-if="!isJuridic">
              portador do <b> CPF: {{ person_document | cpf }} </b>
            </span>
            <span v-if="isJuridic">
              portador do <b>CNPJ: {{ person_document | cnpj }}</b> </span
            >, a importância de
            <b
              >{{ bill_data.bill.payed_value | moneyBr }}({{
                bill_data.bill.payed_value | decimal | extenso
              }})</b
            >
            correspondente ao documento/parcela Nº
            <b>{{ bill_data.bill.document }}</b
            >.
          </b-col>
        </b-row>
        <b-row v-if="hasOrder">
          <br />
          <b-col cols="12"> referente a: </b-col>
          <b-col cols="6">
            <br />
            <table class="table table-sm">
              <thead>
                <tr>
                  <th>Produto</th>
                  <th style="text-align: center">Quantidade</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in bill_data.products" :key="index">
                  <td>{{ row.product }}</td>
                  <td style="text-align: center">{{ row.quantity }}</td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
        <br />

        <b-row>
          <b-col>
            {{ company.address.city }} -
            {{ bill_data.bill.payed_at | dateBr }}
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col
            >{{ company.name }} <br />
            CNPJ: {{ company.cnpj | cnpj }}</b-col
          >
        </b-row>
        <b-row>
          <b-col>
            {{ company.address.address }}, {{ company.address.number }}
            {{ company.address.district }} - {{ company.address.city }}-{{
              company.address.state
            }}
            - CEP:
            {{ company.address.zipcode | cep }}
            <span v-if="company.address.complement"
              >,{{ company.address.complement }}</span
            >
          </b-col>
          <br />
        </b-row>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
export default {
  props: {
    bill_data: {
      type: Object,
    },
  },

  computed: {
    company() {
      return this.$store.state.company;
    },
    hasOrder() {
      return this.bill_data.bill.order_id != null;
    },

    isJuridic() {
      return this.bill_data.bill.person.person_type == "j";
    },

    person_document() {
      if (this.isJuridic) {
        return this.bill_data.bill.person.cnpj
          ? this.bill_data.bill.person.cnpj
          : "";
      }
      if (!this.isJuridic) {
        return this.bill_data.bill.person.cpf
          ? this.bill_data.bill.person.cpf
          : "";
      }
    },
  },
};
</script>

<style scoped>
.table thead th {
  font-size: 70%;
}
.table tbody td {
  font-size: 70%;
}
h4.card-title {
  text-align: center;
}

body {
  margin: 0;
  padding: 0;
  background-color: #fafafa;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol";
  font-size: 8pt;
}

* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.page {
  /* width: 21cm; */
  /* min-height: 29.7cm; */
  padding: 0.5cm;
  margin: 0.5cm;
  /* border: 1px #d3d3d3 solid; */
  /*    border-radius: 5px;*/
  /* background: white; */
  /* box-shadow: 0 0 5px rgba(0, 0, 0, 0.1); */
}

.subpage {
  padding: 0cm;
  /*    border: 5px red solid;*/
  height: 256mm;
  outline: 2cm #ffeaea solid;
}

@page {
  size: A4;
  margin: 0.5cm;
  padding: 0.5cm;
}

@media print {
  .table thead th {
    font-size: 70%;
  }
  .table tbody td {
    font-size: 70%;
  }
  h4.card-title {
    text-align: center;
  }
  .card {
    border: none;
    page-break-after: always;
    size: A4;
    margin: 0.5cm;
    padding: 0.5cm;
  }
}
</style>
